import React, { useContext, useState, useEffect, useCallback, useRef } from "react";
import { useLabels } from '../../hooks';
import styles from './Nakdan.module.scss';
import Button, { buttonType } from '../../components/Button';
import { DeviceContext } from '../../contexts';
import { useNakdanWord } from '../../api/useNakdanWord';
import { useNakdanRestoreKtivMale } from '../../api/useNakdanRestoreKtivMale'
import Icon from '../../components/Icon';
import Loader from '../../components/Loader';
import { trackEvent } from '../../utils/analytics';

const WordVocalization = ({ selectedWord, baseWord, setSelectedWord, onWordChange, closeVwAlert = "" }) => {
    const { getLabel } = useLabels();
    const { isMobileView } = useContext(DeviceContext);
    const [words, setWords] = useState();
    const [wordWithoutNiqqud, setWordWithoutNiqqud] = useState(null);
    const [finalWord, setFinalWord] = useState(selectedWord);
    const [exArr, setExArr] = useState(null);
    const [arrLetters, setArrLetters] = useState();
    const [letter, setLetter] = useState(null);
    const [indexLetter, setIndexLetter] = useState(0);
    const [manualVocalization, setManualVocalization] = useState(false)
    const [shinDot, setShinDot] = useState('');
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [showLoader, setShowLoader] = useState(true);
    const apiWord = baseWord || selectedWord;
    const eventFired = useRef(false);
    const { loader: loadNakdanWord, error: errorNakdanWord, data: dataNakdanWord } = useNakdanWord(apiWord);
    const { loader: loaduseNakdanRestoreKtivMale, error: erroruseNakdanRestoreKtivMale, data: dataNakdanRestoreKtivMale } = useNakdanRestoreKtivMale(apiWord);

    const specialChars = ['"', "'", '(', ')', '[', ']', '{', '}', '!', '?', '.', ',', ':', ';', '-', '–', '—', '״', '׳', '…'];

    // Reset all word state whenever the user selects a new word, regardless of baseWord.
    useEffect(() => {
        eventFired.current = false;
        setFinalWord(selectedWord);
        setDropdownOpen(false);
        setManualVocalization(false);
    }, [selectedWord]);

    useEffect(() => {
        if (dataNakdanWord?.OutputWord) {
            setWords(dataNakdanWord.OutputWord)
            setShowLoader(false)
            if (!eventFired.current) {
                trackEvent('nikud_completed');
                eventFired.current = true;
            }
        }
    }, [dataNakdanWord]);

    useEffect(() => {
        if (apiWord && dataNakdanRestoreKtivMale?.OutputText)
            setWordWithoutNiqqud(dataNakdanRestoreKtivMale?.OutputText);
    }, [apiWord, dataNakdanRestoreKtivMale])

    useEffect(() => {
        if (wordWithoutNiqqud && indexLetter == 0) {
            let i = 0;
            while (i < wordWithoutNiqqud.length) {
                if (specialChars.includes(wordWithoutNiqqud[i])) {
                    i++;
                }
                else {
                    setLetter(wordWithoutNiqqud[i])
                    setIndexLetter(i)
                    i = wordWithoutNiqqud.length;
                }
            }
        }
    }, [wordWithoutNiqqud, indexLetter])

    useEffect(() => {
        if (letter) {
            if (letter < "א" || letter > "ת") {
                return;
            }
            initLetter(letter);
        }
    }, [letter])

    useEffect(() => {
        var shva = '\u05B0', hatafsegol = '\u05B1', hatafpatah = '\u05B2', hatafqamats = '\u05B3', hiriq = '\u05B4', tsere = '\u05B5';
        var segol = '\u05B6', patah = '\u05B7', qamats = '\u05B8', holam = '\u05B9', qubuts = '\u05BB', dagesh = '\u05BC';
        let tempExArr = [];
        tempExArr['א'] = [dagesh];
        tempExArr['ב'] = [];
        tempExArr['ג'] = [];
        tempExArr['ד'] = [hatafsegol, hatafpatah, hatafqamats];
        tempExArr['ה'] = [true, dagesh, patah + dagesh, false, dagesh];
        tempExArr['ו'] = [hatafsegol, hatafpatah, hatafqamats];
        tempExArr['ז'] = [hatafsegol, hatafpatah, hatafqamats];
        tempExArr['ח'] = [dagesh];
        tempExArr['ט'] = [hatafsegol, hatafpatah, hatafqamats];
        tempExArr['י'] = [hatafsegol, hatafpatah, hatafqamats];
        tempExArr['כ'] = [hatafsegol, hatafpatah, hatafqamats];
        tempExArr['ל'] = [hatafsegol, hatafpatah, hatafqamats];
        tempExArr['מ'] = [hatafsegol, hatafpatah, hatafqamats];
        tempExArr['נ'] = [hatafsegol, hatafpatah, hatafqamats];
        tempExArr['ס'] = [hatafsegol, hatafpatah, hatafqamats];
        tempExArr['ע'] = [dagesh];
        tempExArr['פ'] = [hatafsegol, hatafpatah];
        tempExArr['צ'] = [];
        tempExArr['ק'] = [hatafsegol, hatafpatah, hatafqamats];
        tempExArr['ר'] = [dagesh, hatafsegol, hatafpatah, hatafqamats];
        tempExArr['ש'] = [hatafsegol, hatafpatah, hatafqamats];
        tempExArr['ת'] = [hatafsegol, hatafpatah, hatafqamats];
        tempExArr['ך'] = [true, '', shva, qamats, qamats + dagesh];
        tempExArr['ם'] = [''];
        tempExArr['ן'] = [''];
        tempExArr['ף'] = [''];
        tempExArr['ץ'] = [''];

        setExArr(tempExArr)
    }, [exArr])

    const handleSaveClick = useCallback(() => {
        if (!manualVocalization) {
            onWordChange(finalWord)
        }
        else
            onWordChange(wordWithoutNiqqud);
        setSelectedWord(null)
        if (closeVwAlert)
            closeVwAlert()

    }, [onWordChange, setSelectedWord, manualVocalization, finalWord, wordWithoutNiqqud]);

    const handleSelectWord = useCallback((event) => {
        setManualVocalization(false)
        const { prefix, suffix } = extractPrefixSuffix(selectedWord, specialChars);
        setFinalWord(prefix + event.target.value + suffix);
    }, [setManualVocalization, setFinalWord, selectedWord, specialChars]);

    const handleDropdownSelect = useCallback((wordValue) => {
        setManualVocalization(false);
        const { prefix, suffix } = extractPrefixSuffix(selectedWord, specialChars);
        setFinalWord(prefix + wordValue + suffix);
        setDropdownOpen(false);
    }, [setManualVocalization, setFinalWord, selectedWord, specialChars]);

    const initLetter = useCallback((letter) => {
        if (letter != null) {
            if (letter < "א" || letter > "ת")
                return;
            var Letters = [letter];
            if (letter == 'ש') {
                Letters.push(letter + String.fromCharCode(0x05C1));
                Letters.push(letter + String.fromCharCode(0x05C2));
            }
            for (var i = 0; i < 10; i++) {
                Letters.push(letter + String.fromCharCode(i + 0x05B0));
            }
            Letters.push(letter + String.fromCharCode(0x05BB));
            Letters.push(Letters[0] + String.fromCharCode(0x05BC));
            for (var i = 0; i < 10; i++) {
                Letters.push(letter + String.fromCharCode(i + 0x05B0) + String.fromCharCode(0x05BC));
            }
            Letters.push(letter + String.fromCharCode(0x05BB) + String.fromCharCode(0x05BC));
            setArrLetters(Letters);
        }
    }, [setArrLetters, letter]);

    const isNikudExcluded = useCallback((letter, nikud) => {
        const letArr = exArr[letter];
        if (letArr == null)
            return true;
        let includeNikud = false;
        for (let i = 0; i < letArr.length; i++) {
            if (typeof letArr[i] == 'boolean') {
                includeNikud = letArr[i];
                i++;
            }
            if ((!includeNikud && nikud.indexOf(letArr[i]) >= 0) || (includeNikud && nikud == letArr[i])) {
                return !includeNikud;
            }
        }
        return includeNikud;
    }, [exArr]);

    const replaceLetter = useCallback((newLetter) => {
        const hasRightDot = newLetter === 'שׁ';
        const hasLeftDot = newLetter === 'שׂ';
        const hasOtherNikud = /^ש[\u0591-\u05C7]/.test(newLetter) && !hasRightDot && !hasLeftDot;

        if (hasRightDot) {
            setShinDot('\u05C1');
        } else if (hasLeftDot) {
            setShinDot('\u05C2');
        }

        setManualVocalization(true)
        const splitWord = splitLettersWithNikud(wordWithoutNiqqud);
        splitWord[indexLetter] = newLetter;
        if (shinDot != '')
            splitWord[indexLetter] += shinDot
        const updatedWord = splitWord.join('');
        setWordWithoutNiqqud(updatedWord);
        
        let i = indexLetter;
        while (i < splitWord.length - 1 && (!hasRightDot && !hasLeftDot)) {
            if (!specialChars.includes(splitWord[i + 1])) {
                setLetter(splitWord[i + 1])
                setShinDot('')
                setIndexLetter(i + 1)
                i = splitWord.length;
            }
            else {
                i++;
            }
        }

    }, [indexLetter, wordWithoutNiqqud]);

    const splitLettersWithNikud = useCallback((word) => {
        const letters = [];
        for (let i = 0; i < word.length; i++) {
            if (word[i] >= '\u05D0' && word[i] <= '\u05EA' || specialChars.includes(word[i])) {
                letters.push(word[i]);
            } else {
                letters[letters.length - 1] += word[i];
            }
        }
        return letters;
    }, []);

    let startY = 0;
    const handleTouchStart = useCallback((event) => {
        startY = event.touches[0].clientY;
    }, []);

    const handleTouchMove = useCallback((event) => {
        const currentY = event.touches[0].clientY;
        if (currentY - startY > 50) {
            setSelectedWord(null);
            if (closeVwAlert)
                closeVwAlert()
        }
    }, [setSelectedWord]);

    const removeNiqqudFromLetter = useCallback((letter) => {
        return letter.replace(/[\u0591-\u05C7]/g, '');
    }, [letter]);

    const isSpecialLetter = useCallback((letter) => {
        return (specialChars.includes(letter))
    }, [specialChars]);

    // Helper to extract prefix/suffix special chars
    function extractPrefixSuffix(word, specialChars) {
        let prefix = '';
        let suffix = '';
        let start = 0;
        let end = word.length - 1;
        while (start <= end && specialChars.includes(word[start])) {
            prefix += word[start];
            start++;
        }
        while (end >= start && specialChars.includes(word[end])) {
            suffix = word[end] + suffix;
            end--;
        }
        return { prefix, suffix };
    }

    return (<>
        {!isMobileView && words &&
            <div className={styles.word_vocalization}>
                <div className={styles.nakdan_More_options}
                    onMouseLeave={() => setDropdownOpen(false)}
                >
                    <span onMouseEnter={() => setDropdownOpen(true)}>
                        {getLabel('nakdan_More_options')}
                    </span>
                    <div className={styles.other_options}>
                        <div className={styles.custom_dropdown_wrapper}>
                            <div className={styles.custom_dropdown_display} onClick={() => setDropdownOpen(prev => !prev)} title={finalWord.trim()}>
                                <span>{finalWord.trim()}</span>
                                <span className={styles.dropdown_arrow}>▾</span>
                            </div>
                            {dropdownOpen && (
                                <ul className={styles.custom_dropdown_list}>
                                    {words.map((word, index) => {
                                        const { prefix, suffix } = extractPrefixSuffix(selectedWord, specialChars);
                                        const isSelected = (prefix + word.Word + suffix) === finalWord;
                                        return (
                                            <li
                                                key={index}
                                                className={`${styles.custom_dropdown_item}${isSelected ? ` ${styles.custom_dropdown_item_active}` : ''}`}
                                                onClick={() => handleDropdownSelect(word.Word)}
                                            >
                                                {word.Word}
                                            </li>
                                        );
                                    })}
                                </ul>
                            )}
                        </div>
                        <Button type={buttonType.premium} className={styles.more_options_replace_btn} onClick={handleSaveClick}>
                            {getLabel('nakdan_replace')}
                        </Button>
                    </div>
                </div>
                <div className={styles.nakdan_Manual_Vocalization_extended}>
                    <div className={styles.wrap_view_word}>
                        <span>{getLabel('nakdan_Manual_Vocalization_extended')}</span>
                        <div className={styles.wiew_word}>
                            {wordWithoutNiqqud && splitLettersWithNikud(wordWithoutNiqqud).map((letter, index) => {
                                const basicLetter = removeNiqqudFromLetter(letter);
                                const isSpecial = isSpecialLetter(basicLetter);
                                
                                return isSpecial ? (
                                    <span 
                                        className={styles.one_letter} 
                                        key={index}
                                    >
                                        {letter}
                                    </span>
                                ) : (
                                    <button 
                                        className={index === indexLetter ? `${styles.one_letter} ${styles.bold_one_letter}` : styles.one_letter} 
                                        key={index} 
                                        onClick={() => { setLetter(basicLetter); setIndexLetter(index); setShinDot('') }}
                                    >
                                        {letter}
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                    <div className={styles.letters}>
                        {arrLetters && arrLetters.map((le, index) => {
                            if (letter === 'ש' && index === 3) {
                                return (
                                    <React.Fragment key={index}>
                                        <div style={{ flexBasis: '100%', height: 0 }} />
                                        <Button
                                            value={le}
                                            className={isNikudExcluded(le.charAt(0), le.slice(1)) ? `${styles.letter} ${styles.dark_letter}` : styles.letter}
                                            onClick={() => replaceLetter(le)}
                                        >
                                            {le}
                                        </Button>
                                    </React.Fragment>
                                );
                            }
                            return (
                                <Button
                                    key={index}
                                    value={le}
                                    className={isNikudExcluded(le.charAt(0), le.slice(1)) ? `${styles.letter} ${styles.dark_letter}` : styles.letter}
                                    onClick={() => replaceLetter(le)}
                                >
                                    {le}
                                </Button>
                            );
                        })}
                    </div>
                </div>
                <div className={styles.buttons_replace}>
                    <Button type={buttonType.premium} className={styles.cancel_button_submit} onClick={() => setSelectedWord(null)}>{getLabel('nakdan_cancel')}</Button>
                    <Button type={buttonType.premium} className={styles.replace_button_submit} onClick={handleSaveClick}>{getLabel('nakdan_replace')}</Button>
                </div>
            </div>
        }
        {isMobileView && words && <div className={styles.word_vocalization}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
        >

            <div className={styles.pull_bar}></div>
            <button className={styles.close} onClick={handleSaveClick}><Icon className={styles.close_icon} icon="close" title={getLabel('popup_close_icon_title')} /></button>
            <div className={styles.nakdan_More_options}>



                <span>{getLabel('nakdan_More_options')}</span>
                <div className={styles.other_options}>
                    <select className={styles.select} value={finalWord}
                        onChange={handleSelectWord}
                        onMouseDown={(e) => {
                            e.target.value = "";
                        }}>
                        {words.map((word, index) => (
                            <option key={index} value={word.Word}>{word.Word}</option>
                        ))}
                    </select>
                </div>
            </div>
            <div className={styles.nakdan_Manual_Vocalization_extended}>
                <div className={styles.wrap_view_word}>
                    <span>{getLabel('nakdan_Manual_Vocalization_extended')}</span>
                    <div className={styles.wiew_word}>
                        {wordWithoutNiqqud && splitLettersWithNikud(wordWithoutNiqqud).map((letter, index) => {
                            const basicLetter = removeNiqqudFromLetter(letter);
                            const isSpecial = isSpecialLetter(basicLetter);
                            
                            return isSpecial ? (
                                <span 
                                    className={styles.one_letter} 
                                    key={index}
                                >
                                    {letter}
                                </span>
                            ) : (
                                <button 
                                    className={index === indexLetter ? `${styles.one_letter} ${styles.bold_one_letter}` : styles.one_letter} 
                                    key={index} 
                                    onClick={() => { setLetter(basicLetter); setIndexLetter(index); setShinDot('') }}
                                >
                                    {letter}
                                </button>
                            );
                        })}
                    </div>
                </div>
                <div className={styles.letters}>
                    {arrLetters && arrLetters.map((le, index) => {
                        return (
                            <Button
                                key={index}
                                value={le}
                                className={isNikudExcluded(le.charAt(0), le.slice(1)) ? `${styles.letter} ${styles.dark_letter}` : styles.letter}
                                onClick={() => replaceLetter(le)}
                            >
                                {le}
                            </Button>
                        );
                    })}
                </div>
            </div>
            <div className={styles.buttons_replace}>
                <Button type={buttonType.premium} className={styles.replace_button_submit} onClick={handleSaveClick}>{getLabel('nakdan_save')}</Button>
            </div>
        </div >
        }
        {showLoader && <Loader />}
    </>);
};

export default WordVocalization;
